import { Global } from "./../global";
import { LogoMask } from "./logoMask";
import { Ui } from "./ui";
import { TopSnowAnimation } from "./topSnowAnimation";
import { PromotionBnr } from "./../_click/promotionBanner";
// import { Locomo } from "./../_scroll/locomo";
// import { LineModal } from "./../_click/lineModal";
import { gsap } from "gsap";


export const Opening = {
  init:()=>{
    // Opening.posTop=(!Global.isMobile) ? "12vh" : "10vh";
    // Opening.posTop="12vh";
    // Opening.videoSrc=(!Global.isMobile) ? "../video/opening.mp4" : "../video/opening_sp.mp4";
    // Opening.videoSrc="../video/opening.mp4";
    gsap.to("#l-opening",.3,{
      autoAlpha:1,
      onComplete:()=>{
        Opening.openingReady();
      }
    })
  },
  openingReady:()=>{
    // let Y=Opening.posTop;
    let Y="12vh";
    // let src=Opening.videoSrc;
    // Opening.maskTiming=(!Global.isMobile) ? "-=1.2" : "-=0.5";
    let timeL=gsap.timeline();
    let snow = document.getElementById("js-video");
    // snow.setAttribute('src', src);
    LogoMask.init();
    timeL.to('.snow-item01',3,{
      onStart:()=>{
        snow.play()
        LogoMask.play()
      },
      onComplete:()=>{
        gsap.set('.opening-bg',{autoAlpha:0})
        gsap.to(".snow",.6,{autoAlpha:0})
      },
      delay:.8,ease:'Power3.easeOut',y:Y
    })
    // .to('.logo-svgMask',.3,{
    //   autoAlpha:1,
    //   onComplete:()=>{
    //     // gsap.set('.logo-black',{autoAlpha:1})
    //     LogoMask.play()
    //     gsap.set('.opening-bg',{autoAlpha:0})
    //   }
    // }, "-=2.7")
    // .to(".snow",.6,{autoAlpha:0})  // -=0.7
    .to(".frame-left", 3,{
      // delay:0,
      autoAlpha:1,
      ease:'Power4.easeInOut',
      x:0
    },"frameOn")
    .to(".frame-right", 3,{
      delay:.1,
      autoAlpha:1,
      ease:'Power4.easeInOut',
      x:0
    },"frameOn")
    .to(".frame-leftTop", 3,{
      // delay:.5,
      autoAlpha:1,
      ease:'Power4.easeInOut',
      x:0,
      y:0
    },"frameOn")
    .to(".frame-rightTop", 3,{
      delay:.1,
      autoAlpha:1,
      ease:'Power3.easeInOut',
      x:0,
      y:0,
      onStart:()=>{
        Opening.isTopAni()
      }
    },"frameOn")
    .to("#l-opening",1,{
      autoAlpha:0,
      onStart:()=>{
        Ui.ready();
        Opening.isBanner();
        gsap.set('.mv-logo',{opacity:1})
        Opening.footerIn();
      },
      onComplete:()=>{
        // Opening.isModal()
        Opening.scrollIconIn()
        Opening.delete();
      }
    },"-=1")
  },
  topPageReady:()=>{
    //　下層からtopに戻ってきた時↓
    // mvエリアの上下左右の雪表示
    gsap.set('.mv-logo',{opacity:1})

    let timeL=gsap.timeline();
    Opening.delete()
    timeL.to(".frame-left", 3,{
      autoAlpha:1,
      ease:'Power4.easeInOut',
      x:0
    },"frameOn")
    .to(".frame-right", 3,{
      delay:.1,
      autoAlpha:1,
      ease:'Power4.easeInOut',
      x:0
    },"frameOn")
    .to(".frame-leftTop", 3,{
      autoAlpha:1,
      ease:'Power4.easeInOut',
      x:0,
      y:0
    },"frameOn")
    .to(".frame-rightTop", 3,{
      delay:.1,
      autoAlpha:1,
      ease:'Power3.easeOut',
      x:0,
      y:0,
      onStart:()=>{
        Opening.scrollIconIn()
        Opening.footerIn()
      },
      onComplete:()=>{
        Opening.isTopAni()
        Opening.isBanner()
        // Opening.isModal()
      }
    },"frameOn")
  },
  lowPageReady:()=>{
    gsap.to(".frame-rightTop", 2,{
      autoAlpha:1,
      ease:'Power3.easeOut',
      x:0,
      y:0,
      onStart:()=>{
        Opening.isBanner()
        Opening.footerIn()
      },
      onComplete:()=>{
        Ui.ready();
        // Opening.scrollIconIn()
      }
    },"frameOn")
  },
  scrollIconIn:()=>{
    gsap.to('.scroll-inner',1.4,{ease:'Power3.easeOut',y:0,autoAlpha:1})
  },
  isTopAni:()=>{
    Global.isIE ? TopSnowAnimation.ieSlide() : TopSnowAnimation.ready();
  },
  isBanner:()=>{
    if(Global.isBanner){
      PromotionBnr.bannerHandle();
    }
  },
  // bannerIn:()=>{
  //   if(Global.isBanner){
  //     // Locomo.update()
  //     PromotionBnr.fadeIn()
  //   }
  // },
  // isModal:()=>{
  //   if(Global.isLineModal){
  //     LineModal.fadeIn()
  //   }
  // },
  footerIn:()=>{
    gsap.to("#l-footer", 0.5, {
      autoAlpha: 1,
    });
  },
  delete:()=>{
    document.querySelector("#l-opening").remove();
  }
};
